import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBQgwzEqM-HtX6idJeS1paqc0arZlulC8A",
  authDomain: "lappy-ccb5e.firebaseapp.com",
  projectId: "lappy-ccb5e",
  storageBucket: "lappy-ccb5e.firebasestorage.app",
  messagingSenderId: "119059786519",
  appId: "1:119059786519:web:cb35ef43f2bb71c073e552",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
